module.exports = __webpack_public_path__ + "static/media/img-04.b4a442f6.jpg";